var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 14.6669V7.33357C19.2497 7.01207 19.1648 6.69631 19.0039 6.41797C18.843 6.13962 18.6118 5.90849 18.3333 5.74774L11.9167 2.08107C11.638 1.92016 11.3218 1.83545 11 1.83545C10.6782 1.83545 10.362 1.92016 10.0833 2.08107L3.66667 5.74774C3.38824 5.90849 3.15698 6.13962 2.99609 6.41797C2.8352 6.69631 2.75033 7.01207 2.75 7.33357V14.6669C2.75033 14.9884 2.8352 15.3042 2.99609 15.5825C3.15698 15.8608 3.38824 16.092 3.66667 16.2527L10.0833 19.9194C10.362 20.0803 10.6782 20.165 11 20.165C11.3218 20.165 11.638 20.0803 11.9167 19.9194L18.3333 16.2527C18.6118 16.092 18.843 15.8608 19.0039 15.5825C19.1648 15.3042 19.2497 14.9884 19.25 14.6669Z",
    stroke: "#F7F7F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99707 6.38037L10.9996 11.0095L19.0021 6.38037",
    stroke: "#F7F7F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.24V11",
    stroke: "#F7F7F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox);
export default __webpack_public_path__ + "static/media/icon-box.773ef03bcbb7f330ac412f4237ca598d.svg";
export { ForwardRef as ReactComponent };